var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters,"include":[
      'livestock_type_entity',
      'livestock_operation_entity',
      'barn_type_entity',
    ]}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-clone":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }